/**
 * Created by hp on 2017/8/4.
 */
import MainInitComponent from './MainInitComponent';
import MainPopupTab from './MainPopupTab';
import MainPopupTabItem from './MainPopupTabItem';
import MainRecommendBar from './MainRecommendBar';
import MainLivingLecture from './MainLivingLecture';
import MainMixBox from './MainMixBox';
import MainCacheData from './MainCacheData';
import MainGiftBar from './MainGiftBar';
import MainGiftPopup from './MainGiftPopup';
import MainActiveCoupon from './MainActiveCoupon'
import MainIntroSlider from './MainIntroSlider'
import MainNewNav from './MainNewNav'
import MainLimitBar from './MainLimitBar'
import MainFeedConfiguration from './MainFeedConfiguration'
import MainConfigurationBar from './MainConfigurationBar'
import MainStackBlock from './MainStackBlock'
import MainItemListCardView from './MainItemListCardView'

export {
    MainInitComponent,
    MainPopupTab,
    MainPopupTabItem,
    MainRecommendBar,
    MainLivingLecture,
    MainMixBox,
    MainCacheData,
    MainGiftBar,
    MainGiftPopup,
    MainActiveCoupon,
    MainIntroSlider,
    MainNewNav,
    MainLimitBar,
    MainFeedConfiguration,
    MainConfigurationBar,
    MainStackBlock,
    MainItemListCardView,
}


// WEBPACK FOOTER //
// ./src/components/main/index.js